import { render, staticRenderFns } from "./Devolucoes.vue?vue&type=template&id=c41e185c&"
import script from "./Devolucoes.vue?vue&type=script&lang=js&"
export * from "./Devolucoes.vue?vue&type=script&lang=js&"
import style0 from "./Devolucoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports